/**
 * Shared coverage-status display helpers for badges and table sorting.
 */

export function getCoverageStatusBadgeProps(value: string | undefined): {
  color: string;
  label: string;
} {
  const normalized = value?.trim().toLowerCase() ?? "";
  if (normalized === "active" || normalized === "eligible" || normalized === "verified") {
    return { color: "green.6", label: "Eligible" };
  }
  if (
    normalized === "not-eligible" ||
    normalized === "not eligible" ||
    normalized.includes("not eligible")
  ) {
    return { color: "red.7", label: "Not Eligible" };
  }
  return { color: "gray.5", label: "Unknown" };
}

export function getCoverageStatusLabel(value: string | undefined): string {
  return getCoverageStatusBadgeProps(value).label;
}
